import { PROVINCES, STATES } from 'shared-components/src/utils/provinces';

// Checks if dropdown options for state are for the selected country
export const checkSelectedState = (cardholder, keys, countryCode) => keys.includes(cardholder.state) && cardholder.country === countryCode;

// Retrieves an array of state options keys for the dropdown input
// Last ten digits: the same number arrives E.164 in one place and bare in
// another, and both spellings have to pair.
export const subscriberDigits = value => String(value || '').replace(/\D/g, '').slice(-10);

export const stateKeys = STATES.map(s => s.key);
export const provinceKeys = PROVINCES.map(p => p.key);

const ADDRESS_LETTERS = 'a-zA-Z0-9ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ ';
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^\d{7,16}$/;
const ADDRESS1_REGEX = new RegExp(`^[${ADDRESS_LETTERS}',-.]{1,40}$`);
const ADDRESS2_REGEX = new RegExp(`^[${ADDRESS_LETTERS}'#,-.]{1,30}$`);

// The profile form's rules, checked here rather than by the browser: the browser's
// own messages ("Please match the requested format.") follow the browser's language,
// not the portal's. Returns an i18n key, or '' when the field is fine.
export const profileFieldError = (field, cardholder) => {
  const value = String(cardholder[field] ?? '');

  switch (field) {
  case 'email':
    return !value || EMAIL_REGEX.test(value) ? '' : 'profile-errors-email-invalid';
  case 'phone':
    if (!value.trim()) return 'profile-errors-phone-required';
    return PHONE_REGEX.test(value) ? '' : 'profile-errors-phone-invalid';
  case 'address1':
    if (!value.trim()) return 'profile-errors-address1-required';
    return ADDRESS1_REGEX.test(value) ? '' : 'profile-errors-address1-invalid';
  case 'address2':
    return !value || ADDRESS2_REGEX.test(value) ? '' : 'profile-errors-address2-invalid';
  case 'city':
    return value.trim() ? '' : 'profile-errors-city-required';
  case 'postal_code':
    return value.trim() ? '' : 'profile-errors-postalCode-required';
  default:
    return '';
  }
};

export const contactFields = ['email', 'phone'];
// A read-only address cannot be corrected by the cardholder, so it is not checked:
// a stored value that fails these rules would otherwise block every other edit.
export const addressFields = ['address1', 'address2', 'city', 'postal_code'];

// verify login credentials so user can change password
export const verifyLoginCreds = async payload =>
  fetch('/api/v1/cardholder_portal/verify_login_credentials', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
    .then(res => res.json())
    .then(body => {
      if (body.error) throw new Error(body.error.message);
      return body;
    });